import { Icon } from "@iconify/react";

export type SectionStep = {
  id: string;
  title: string;
  description?: string;
};

type SectionStepperProps = {
  steps: SectionStep[];
  activeStepId: string;
  onStepClick: (step: SectionStep) => void;
  className?: string;
};

export function SectionStepper({
  steps,
  activeStepId,
  onStepClick,
  className = "",
}: SectionStepperProps) {
  const activeIndex = Math.max(
    0,
    steps.findIndex((step) => step.id === activeStepId)
  );

  return (
    <nav aria-label="Profile sections" className={className}>
      <ol>
        {steps.map((step, index) => {
          const isActive = step.id === activeStepId;
          const isComplete = index < activeIndex;

          return (
            <li key={step.id}>
              <button
                type="button"
                aria-current={isActive ? "step" : undefined}
                onClick={() => onStepClick(step)}
                className={`group flex min-h-[72px] w-full items-stretch gap-3 px-4 py-3 text-left transition hover:bg-slate-light ${""}`}
              >
                <span className="relative flex w-9 shrink-0 justify-center">
                  <span
                    className={`relative z-10 inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-md border text-sm font-medium shadow-box ${
                      isActive
                        ? "border-orange-501 bg-orange-501 text-white"
                        : "border-borderColor bg-white text-orange-501"
                    }`}
                  >
                    {isComplete ? (
                      <Icon icon="akar-icons:check" width={16} />
                    ) : (
                      index + 1
                    )}
                  </span>
                  {index < steps.length - 1 && (
                    <span className="absolute bottom-[-24px] top-9 w-px bg-borderColor" />
                  )}
                </span>

                <span className="min-w-0 pt-0.5">
                  <span
                    className={`block truncate text-sm font-medium ${
                      isActive ? "text-orange-501" : "text-black-501"
                    }`}
                  >
                    {step.title}
                  </span>
                  {step.description && (
                    <span className="mt-1 block text-xs0 font-medium leading-4 text-gray-401">
                      {step.description}
                    </span>
                  )}
                </span>
              </button>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
